import React from "react";
import { Button, ButtonProps, GriffelStyle, makeStyles, tokens } from "@fluentui/react-components";
import { pcpTokens } from "../../styles";
import { IStyle } from "@fluentui/react";

const defaultButtonHeight = '45px';

const useStyles = makeStyles({
    primary: {
        border: 0,
        color: "white",
        padding: '14px',
        borderRadius: `${pcpTokens.pcpButtonBorderRadius}`,
        height: defaultButtonHeight,

        ':enabled': {
            background: `linear-gradient(270deg, ${tokens.colorBrandBackground} 0%, ${tokens.colorBrandBackground2} 39%)`,
            boxShadow: '0px 2px 10px 0px #00000026',
        },
        ':enabled:hover': {
            color: "white",
            background: 'linear-gradient(270deg, #2CA7FE 0%, #AD94FA 97%)',
        },
        ':enabled:active': {
            // = pressed state
            background: 'linear-gradient(270deg, #7673FB 61%, #1088F9 100%)',
        },
        ':disabled': {
            color: pcpTokens.pcpColorNeutralStrokeDisabled,  //#96A0B4
            background: 'linear-gradient(270deg, #B6DAFC 0%, #D5D4FD 100%)',
        },
        '&[data-fui-focus-visible]': {
            borderRadius: `${pcpTokens.pcpButtonBorderRadius} !important`,
            boxShadow: `${pcpTokens.pcpButtonFocusedBoxShadow}`,
        }
    },

    secondary: {
        border: 0,
        color: "#000000",
        padding: '14px',
        borderRadius: `${pcpTokens.pcpButtonBorderRadius}`,
        height: defaultButtonHeight,

        ':enabled,:enabled:hover,:enabled:active,:disabled': {
            border: '1px solid transparent',
        },
        ':active:hover': {
            border: '0 transparent !important',
            backgroundColor: `${pcpTokens.pcpColorNeutralBackground1White} !important`,    //overrides '--colorNeutralBackground1Pressed' color
        } as GriffelStyle,
        ':enabled:not([data-fui-focus-visible])': {     //":not" styles are applied since "border" style property can't be overriden does not allow "!important"
            background: 'linear-gradient(white, white) padding-box, linear-gradient(#000000, #000000) border-box',
        },
        ':enabled:hover,:enabled:active': {
            // = both hover and pressed states share the same styles
            color: tokens.colorBrandBackground, // #1088F9
        },
        ':enabled:hover:not([data-fui-focus-visible]),:enabled:active:not([data-fui-focus-visible])': {
            // = both hover and pressed states share the same styles
            background: `linear-gradient(white, white) padding-box, linear-gradient(270deg, ${tokens.colorBrandBackground} 0%, ${tokens.colorBrandBackground2} 39%) border-box`,
        },
        ':disabled': {
            color: '#C8D2E7',
            background: 'linear-gradient(white, white) padding-box, linear-gradient(#C8D2E7, #C8D2E7) border-box',
        },

        '&[data-fui-focus-visible]': {
            borderRadius: `${pcpTokens.pcpButtonBorderRadius} !important`,
            boxShadow: `${pcpTokens.pcpButtonFocusedBoxShadow} !important`,
            background: `${pcpTokens.pcpColorNeutralBackground1White}`,
        },
    },
});


export const PcpPrimaryButton = (props: ButtonProps): JSX.Element => {
    const styles = useStyles();

    return (
        <Button {...props} className={styles.primary}>{props.children}</Button>
    );
};

export const PcpSecondaryButton = (props: ButtonProps): JSX.Element => {
    const styles = useStyles();

    return (
        <Button {...props} appearance={'secondary'} className={styles.secondary}>{props.children}</Button>
    );
};
